import { render, staticRenderFns } from "./Walls.vue?vue&type=template&id=c91505e2&"
import script from "./Walls.vue?vue&type=script&lang=js&"
export * from "./Walls.vue?vue&type=script&lang=js&"
import style0 from "./Walls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports